import { getStringValue } from '~/modules/guarantees/utils.ts';
import { DocStatusEnum, type TDocument } from '~/modules/identification/forms/Documents/types.ts';
import {
  GuaranteesFileType,
  type TGuaranteesApplicationFile,
} from '~/store/guarantees/types.ts';
import { CLIENT_APPROVAL_LETTER_SIGN_TEXT } from './constants.ts';

export const getClientApprovalLetterFile = (
  applicationFiles: TGuaranteesApplicationFile[] = []
): TGuaranteesApplicationFile | null =>
  applicationFiles.find((file) => file.fileType === GuaranteesFileType.LETTER_OF_APPROVAL_CLIENT) ??
  null;

export const getClientApprovalLetterPreviewFileId = (
  applicationFile?: TGuaranteesApplicationFile | null
): string => getStringValue(applicationFile?.fileId);

export const getClientApprovalLetterSigningFileId = (
  applicationFile?: TGuaranteesApplicationFile | null
): string => getStringValue(applicationFile?.fileSignedId || applicationFile?.fileId);

export const getClientApprovalLetterFileName = (
  applicationFile?: TGuaranteesApplicationFile | null
): string =>
  getStringValue(applicationFile?.description) || CLIENT_APPROVAL_LETTER_SIGN_TEXT.previewTitle;

export const buildClientApprovalLetterSigningDocuments = (
  applicationFile?: TGuaranteesApplicationFile | null
): { fileIds: string[]; documents: TDocument[] } => {
  const fileId = getClientApprovalLetterSigningFileId(applicationFile);

  if (!fileId) {
    return { fileIds: [], documents: [] };
  }

  const fileName = getClientApprovalLetterFileName(applicationFile);

  return {
    fileIds: [fileId],
    documents: [
      {
        id: fileId,
        nameDoc: fileName,
        idDictWebDocument: 1,
        idDoc: 1,
        docStatus: [DocStatusEnum.NOT_VERIFIED],
        documentName: fileName,
      },
    ],
  };
};
